'use client';

import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';
import { VideoThoughtsCarouselMobileCard } from '../hcp-thoughts-coursel/video-thoughts-carousel-mobile-card/video-thoughts-carousel-mobile-card';
import { VIDEO_THOUGHTS } from '../constants';

const VideoThoughtsCarouselMobile = () => {
  const swiperRef = useRef<SwiperType | null>(null);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  const handleNextVideoClick = () => {
    const swiper = swiperRef.current;
    if (swiper) {
      const currentIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;
      const currentVideo = videoRefs.current[currentIndex];
      if (currentVideo) {
        currentVideo.pause();
      }
      swiper.slideNext();
    }
  };

  const handleSlideChange = (swiper: SwiperType) => {
    const newActiveIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;
    videoRefs.current.forEach((video, index) => {
      if (video && index !== newActiveIndex) {
        video.pause();
      }
    });
  };

  return (
    <div className="w-full max-w-full overflow-hidden video-thoughts-carousel-wrapper rounded-[16px]">
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .video-thoughts-carousel-wrapper .swiper-wrapper {
            display: flex;
            align-items: stretch;
          }
          .video-thoughts-carousel-wrapper .swiper-slide {
            height: auto;
            display: flex;
            align-items: stretch;
          }
          .video-thoughts-carousel-wrapper .swiper-pagination-bullet {
            fill: rgba(255, 255, 255, 0.30);
            stroke-width: 12px;
            stroke: #FFF;
            background: rgba(255, 255, 255, 0.30);
            opacity: 1;
          }
          .video-thoughts-carousel-wrapper .swiper-pagination-bullet-active {
            fill: #FFF;
            stroke-width: 12px;
            stroke: #FFF;
            background: #FFF;
          }
        `,
        }}
      />
      <Swiper
        modules={[Pagination]}
        spaceBetween={12}
        slidesPerView={1}
        loop={true}
        pagination={{ clickable: true }}
        className="w-full p-0 m-0"
        autoHeight={false}
        wrapperClass="w-full p-0"
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => handleSlideChange(swiper)}
      >
        {VIDEO_THOUGHTS.map((videoThought, index) => (
          <SwiperSlide className="w-full h-full flex items-stretch" key={index}>
            <VideoThoughtsCarouselMobileCard
              caption={videoThought.caption}
              src={videoThought.src}
              thumbnail={videoThought.thumbnail}
              className="h-full w-full"
              onNextVideoClick={handleNextVideoClick}
              videoRef={(ref) => {
                videoRefs.current[index] = ref;
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export { VideoThoughtsCarouselMobile };
